
import NotificationContextProvider from './NotificationContext';
import LanguageContextProvider from './LanguageContext';
import UserContextProvider from './UserContext';
import EnvironmentContextProvider from './EnvironmentContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ptBr from 'dayjs/locale/pt-br';


const MainContextProvider = (props: React.PropsWithChildren) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ptBr}>
            <LanguageContextProvider>
                <EnvironmentContextProvider>
                    <NotificationContextProvider>
                        <UserContextProvider>
                            {props.children}
                        </UserContextProvider>
                    </NotificationContextProvider>
                </EnvironmentContextProvider>
            </LanguageContextProvider>
        </LocalizationProvider>
    );
}


export default MainContextProvider;